"use client";

import { c as _c } from "react/compiler-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { readFragment } from "@opensea/graphql";
import { BottomSheetBody, BottomSheetHeader, BottomSheetHeaderTitle, Flex, Form, Separator, Table } from "@opensea/ui-kit";
import { bn } from "@opensea/utils";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { useIsFormSubmitDisabled } from "../../../../../lib/form/valid";
import { transferFlowFormSchema } from "../../schema";
import { TransferFlowFormItem } from "../TransferFlowFormItem";
import { TransferFlowForm_itemFragment } from "./TransferFlowForm.fragment";
import { TransferFlowRecipient } from "./TransferFlowRecipient";
export const TransferFlowForm = t0 => {
  const $ = _c(35);
  const {
    defaultValues,
    items: itemKeys,
    onSubmit
  } = t0;
  const t = useTranslations("wallet.TransferFlowForm");
  const items = itemKeys.map(_temp);
  const t1 = defaultValues ?? getDefaultFormValues(items);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = zodResolver(transferFlowFormSchema);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = {
      defaultValues: t1,
      resolver: t2,
      mode: "onChange"
    };
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const methods = useForm(t3);
  const {
    handleSubmit,
    control
  } = methods;
  let t4;
  if ($[3] !== control) {
    t4 = {
      control,
      name: "items"
    };
    $[3] = control;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const formItems = useWatch(t4);
  const tableItems = formItems.flatMap(formItem => {
    const matchedItem = items.find(item => item.id === formItem.id);
    return matchedItem ? [matchedItem] : [];
  });
  const isFormSubmitDisabled = useIsFormSubmitDisabled(control);
  const T0 = FormProvider;
  const T1 = Form;
  let t5;
  if ($[5] !== handleSubmit || $[6] !== onSubmit) {
    t5 = handleSubmit(onSubmit);
    $[5] = handleSubmit;
    $[6] = onSubmit;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const T2 = BottomSheetHeader;
  const T3 = BottomSheetHeaderTitle;
  const t6 = t("title", {
    count: items.length
  });
  let t7;
  if ($[8] !== T3 || $[9] !== t6) {
    t7 = <T3>{t6}</T3>;
    $[8] = T3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== T2 || $[12] !== t7) {
    t8 = <T2>{t7}</T2>;
    $[11] = T2;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t10;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TransferFlowRecipient />;
    t10 = <Separator className="my-0.5" />;
    $[14] = t10;
    $[15] = t9;
  } else {
    t10 = $[14];
    t9 = $[15];
  }
  let t11;
  if ($[16] !== tableItems) {
    t11 = <Table itemKey={_temp2} items={tableItems} renderRow={TransferFlowFormItem} size="lg" />;
    $[16] = tableItems;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t) {
    t12 = t("reviewButton");
    $[18] = t;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== isFormSubmitDisabled || $[21] !== t12) {
    t13 = <Flex className="justify-end"><Button disabled={isFormSubmitDisabled} type="submit">{t12}</Button></Flex>;
    $[20] = isFormSubmitDisabled;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <BottomSheetBody>{t9}{t10}{t11}{t13}</BottomSheetBody>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== T1 || $[27] !== t14 || $[28] !== t5 || $[29] !== t8) {
    t15 = <T1 onSubmit={t5}>{t8}{t14}</T1>;
    $[26] = T1;
    $[27] = t14;
    $[28] = t5;
    $[29] = t8;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== T0 || $[32] !== methods || $[33] !== t15) {
    t16 = <T0 {...methods}>{t15}</T0>;
    $[31] = T0;
    $[32] = methods;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
};
const getDefaultFormValues = items => {
  return {
    recipient: {
      identifier: "",
      resolvedAddress: "",
      isResolving: false
    },
    items: items.map(item => ({
      ownedQuantity: bn(item.ownership?.quantity ?? "0").toNumber(),
      quantity: 1,
      id: item.id
    }))
  };
};
function _temp(itemKey) {
  return readFragment(TransferFlowForm_itemFragment, itemKey);
}
function _temp2(_, index) {
  return index;
}